import React, { useEffect, useState } from "react";
import { apiGet } from "../../utils/api";

const StudyGroups = () => {
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    async function exibir() {
      const payload = apiGet("/study_group");

      setGroups((await payload).data.data);
    }
    exibir();
  }, []);

  return (
    <div>
      <section id="grupos" style={{ paddingTop: "100px" }}>
        <div class="row text-center justify-content-center">
          <h2 class="text-black mb-4">Grupos de Estudo</h2>
        </div>

        {groups && groups.length
          ? groups.map((group) => {
              return (
                <div className="row mx-5">
                  <div className="card mb-3">
                    <div className="row">
                      <div className="card-body">
                        <div key={group.group_id} className="card-title">
                          {group.title}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          : null}
      </section>
    </div>
  );
};

export default StudyGroups;
